import React from 'react'
import styled from 'styled-components'
import Spinner from '../Spinner/Spinner'

const CenterContainer = styled.div`
    width: 100vw;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 50px 0;
`

const PageSpinner = () => (
    <CenterContainer>
        <Spinner strokeWidth={3} size={35} tint="#3C8EFF" />
    </CenterContainer>
)

export default PageSpinner
